import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";

export default function About() {
  const { t } = useTranslation();
  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);

  return (
    <div className="about-page">
      {/* Page Header */}
      <section className="page-header" data-aos="fade-up">
        <h1>{t("about.title")}</h1>
      </section>

      {/* Who We Are Section */}
      <section className="about-who-section" data-aos="fade-up">
        <h2 className="section-title">{t("about.whoWeAre.title")}</h2>
        <p className="about-description">{t("about.whoWeAre.description")}</p>
      </section>

      {/* Achievements Section */}
      <section className="about-achievements-section" data-aos="fade-up">
        <h2 className="section-title">{t("about.achievements.title")}</h2>
        <div className="achievements-grid">
          <div className="achievement-card" data-aos="zoom-in">
            <div className="achievement-number">95%</div>
            <p>{t("about.achievements.customerSatisfaction")}</p>
          </div>
          <div className="achievement-card" data-aos="zoom-in" data-aos-delay="100">
            <div className="achievement-number">85%</div>
            <p>{t("about.achievements.salesIncrease")}</p>
          </div>
          <div className="achievement-card" data-aos="zoom-in" data-aos-delay="200">
            <div className="achievement-number">90%</div>
            <p>{t("about.achievements.efficiencyImprovement")}</p>
          </div>
          <div className="achievement-card" data-aos="zoom-in" data-aos-delay="300">
            <div className="achievement-number">80%</div>
            <p>{t("about.achievements.revenueIncrease")}</p>
          </div>
        </div>
      </section>

      {/* Goals Section */}
      <section className="about-goals-section" data-aos="fade-up">
        <h2 className="section-title">{t("about.goals.title")}</h2>
        <div className="goals-grid">
          <div className="goal-card" data-aos="fade-right">
            <div className="goal-icon">🎯</div>
            <h3>{t("about.goals.goal1.title")}</h3>
            <p>{t("about.goals.goal1.description")}</p>
          </div>
          <div className="goal-card" data-aos="fade-up">
            <div className="goal-icon">⭐</div>
            <h3>{t("about.goals.goal2.title")}</h3>
            <p>{t("about.goals.goal2.description")}</p>
          </div>
          <div className="goal-card" data-aos="fade-left">
            <div className="goal-icon">📈</div>
            <h3>{t("about.goals.goal3.title")}</h3>
            <p>{t("about.goals.goal3.description")}</p>
          </div>
          <div className="goal-card" data-aos="fade-up">
            <div className="goal-icon">⚡</div>
            <h3>{t("about.goals.goal4.title")}</h3>
            <p>{t("about.goals.goal4.description")}</p>
          </div>
        </div>
      </section>
    </div>
  );
}
